export default {"src":"/_next/static/media/empty.5c5cf843.svg","height":476,"width":558,"blurWidth":0,"blurHeight":0};